/**
 * Created by Ayush Kulshrestha on 18/09/2019.
 */

export const httpConstants = {
    METHOD_TYPE: {
        POST: "POST",
        PUT: "PUT",
        GET: "GET",
        DELETE: "DELETE",
    },
    CONTENT_TYPE: {
        APPLICATION_JSON: "application/json",
        MULTIPART_FORM_DATA: "multipart/form-data",
        APPLICATION_FORM_URLENCODED: "application/x-www-form-urlencoded",
        IMAGE_PNG: "image/png",
    },
    DEVICE_TYPE: {
        WEB: "web",
    },
    // BASE_URL: "https://kaarigar-app.herokuapp.com/",
    BASE_URL: "https://api.mygoldwork.com/",
    // BASE_URL: "http://localhost:3000/",
    API_END_POINT: {
        ADMIN_LOGIN: "admin-login",
        USER: "user",
        USER_LIST: "get-users",
        CATEGORY_LIST: "category-list",
        PARENT_CATEGORY_LIST: "parent-category-list",
        ADD_CATEGORY: "category",
        ADD_PARENT_CATEGORY: "parent-category",
        ITEMS_LIST: "items-list",
        BANNER: "banner",
        BANNER_LIST: "banner",
        ADD_ITEM: "item",
        ORDER_LIST: "orders",
        USER_CATALOGUE_LIST: "catalogues",
        USER_CATALOGUE_BY_ID: "catalogue-by-id",
        UPDATE_CATALOGUE_STATUS: "catalogue",
        PLANS_LIST: "plans",
        SUBSCRIPTION_LIST: "subscriptions",
        SUBSCRIPTION: "subscription",
        PLAN: "plan",
        REFERRAL: "referral-user",
        REFERRAL_LIST: "referral-users",
        REFERRED_USER_LIST: "referred-users",
        UPDATE_ORDER: "order",
        HOME_API: "home-api",
        GOLD_API: "gold-api",
        UPDATE_GOLD_API: "update-metal-price",
        BULK_NOTIF_API: "send-bulk-notification",
        BULK_NOTIF_OTP_API: "send-bulk-notification-otp",
        UPLOAD_FILE: "uploadFile",

    },
};

export const eventConstants = {
    SHOW_LOADER: "SHOW_LOADER",
    HIDE_LOADER: "HIDE_LOADER",
    SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
    UPDATE_USER_DATA_SUCCESS: "UPDATE_USER_DATA_SUCCESS",
    LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
};

export const cookiesConstants = {
    DEVICE_ID: "deviceId",
    SESSION_TOKEN: "sessionToken",
    ACCESS_TOKEN: "accessToken",
    ID_TOKEN: "idToken",
    EXPIRES_AT: "expiresAt",
    USER: "user",
    COMPANY: "company",
    USER_META_DATA: "userMetaData",
    USER_DETAILS: "userDetails",
};

export const pathConstants = {
    LOGIN: "/",
    SIGN_UP: "/sign-up",
    DASHBOARD_MENU: {
        HOME: "/dashboard/home",
        ADD_HOSPITALS: "/dashboard/hospitals/add",
        CATEGORIES: "/dashboard/categories",
        SUB_CATEGORIES: "/dashboard/sub-categories",
        BANNERS: "/dashboard/banners",
        ADD_PARENT_CATEGORIES: "/dashboard/categories/add",
        ADD_CATEGORIES: "/dashboard/sub-categories/add",
        ADD_BANNERS: "/dashboard/banners/add",
        ADD_PRODUCT: "/dashboard/items/add",
        ADD_CONTENT: "/dashboard/content/add",
        CATALOGUE: "/dashboard/catalogue",
        PRODUCTS: "/dashboard/items",
        SETTINGS: "/dashboard/settings",
        USERS: "/dashboard/users",
        PLANS: "/dashboard/plans",
        SUBSCRIPTIONS: "/dashboard/subscriptions",
        REFERRALS: "/dashboard/referrals",
    },
};
export const dashboardMenuImages = {
    HOSPITALS: {
        true: "/images/hospital-active.svg",
        false: "/images/hospital-inactive.svg",
    },
    ADVERTISERS: {
        true: "/images/category-active.svg",
        false: "/images/category-inactive.svg",
    },
    CATALOGUE: {
        true: "/images/reports-active.svg",
        false: "/images/reports-inactive.svg",
    },
    CATEGORIES: {
        true: "/images/content-active.svg",
        false: "/images/content-inactive.svg",
    },
    PLANS: {
        true: "/images/content-active.svg",
        false: "/images/content-inactive.svg",
    },
    REFERRALS: {
        true: "/images/content-active.svg",
        false: "/images/content-inactive.svg",
    },
    PRODUCTS: {
        true: "/images/products-active.svg",
        false: "/images/products-inactive.svg",
    },
    SETTINGS: {
        true: "/images/settings-active.svg",
        false: "/images/settings-inactive.svg",
    },
};
export const orderStatus = {
    PENDING: 'PENDING',
    ACCEPTED_BY_ADMIN: 'ACCEPTED_BY_ADMIN',
    REJECTED_BY_ADMIN: 'REJECTED_BY_ADMIN',
    ACCEPTED_BY_USER: 'ACCEPTED_BY_USER',
    REJECTED_BY_USER: 'REJECTED_BY_USER',
    ORDER_PREPARED: 'ORDER_PREPARED',
    PRODUCT_APPROVED_BY_USER: 'PRODUCT_APPROVED_BY_USER',
    PRODUCT_REJECTED_BY_USER: 'PRODUCT_REJECTED_BY_USER',
    ORDER_DISPATCHED: 'ORDER_DISPATCHED',
    ORDER_DELIVERED: 'ORDER_DELIVERED',
    ORDER_CANCELLED: 'ORDER_CANCELLED'
}
